import React from 'react';
import PropTypes from 'prop-types';
import { Button, HeadingText, BodyText } from '@paypalcorp/pp-react';
import getLocaleMessages from '../../../utils/localesMessages';
import { appendCdnHostName } from '../../../../utility/geoUtils';

const { header, loginButton, signUp } = getLocaleMessages('buttonsV3/login');

const Login = ({ handleLogin, handleSignUp }) => {
  return (
    <div className="login-header-container">
      <div className="button-container">
        <HeadingText size="hero" className="button-container-header">
          {header.title}
        </HeadingText>
        <BodyText className="button-container-body">{header.body}</BodyText>
        <Button
          className="login-button"
          id="button-factory-login"
          type="submit"
          onClick={handleLogin}
        >
          {loginButton}
        </Button>
        <Button secondary onClick={handleSignUp} id="button-factory-signup">
          {signUp}
        </Button>
      </div>
      <div className="image-container">
        <img
          src={appendCdnHostName(
            '/paypal-ui/illustrations/focused/svg/donate-button-desktop-mobile.svg'
          )}
          role="presentation"
        />
      </div>
    </div>
  );
};

Login.propTypes = {
  handleLogin: PropTypes.func,
  handleSignUp: PropTypes.func,
};

export default Login;
